import React, { useState } from 'react';
import { useModal } from '../context/ModalContext';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';

const ContactModal = () => {
  const { isModalOpen, closeModal } = useModal();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country: 'Botswana',
    service: 'Web & Web App Development',
    message: ''
  });

  if (!isModalOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Routing Logic based on country
    const targetEmail = formData.country === 'South Africa' ? 'info.sa@lema.systems' : 'info@lema.systems';
    
    // Generate mailto link for native email client fallback
    const subject = `New Project Inquiry: ${formData.service}`;
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\nCountry: ${formData.country}\nService: ${formData.service}\n\nMessage:\n${formData.message}`;
    
    window.location.href = `mailto:${targetEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    closeModal();
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content animate-fade-in" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={closeModal}>
          <CloseIcon />
        </button>
        
        <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Let's Start a Project</h2>
        <p className="text-muted mb-4">Fill out the form below and our team will get back to you shortly.</p>
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" name="name" required value={formData.name} onChange={handleChange} placeholder="John Doe" />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" required value={formData.email} onChange={handleChange} placeholder="john@example.com" />
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Country of Contact</label>
              <select name="country" value={formData.country} onChange={handleChange}>
                <option value="Botswana">Botswana (HQ)</option>
                <option value="South Africa">South Africa</option>
              </select>
            </div>
            <div className="form-group">
              <label>Service of Interest</label>
              <select name="service" value={formData.service} onChange={handleChange}>
                <option value="Web & Web App Development">Web & Web App Development</option>
                <option value="Mobile App Development">Mobile App Development</option>
                <option value="Cloud Application Development">Cloud Application Development</option>
                <option value="USSD Development">USSD Development</option>
                <option value="API Development & Integrations">API Development & Integrations</option>
                <option value="IT Consulting">IT Consulting</option>
              </select>
            </div>
          </div>
          
          <div className="form-group">
            <label>Project Details / Message</label>
            <textarea name="message" required rows="4" value={formData.message} onChange={handleChange} placeholder="Tell us about your project goals..."></textarea>
          </div>
          
          <button type="submit" className="btn btn-primary btn-full">
            Send Inquiry <SendIcon fontSize="small" style={{ marginLeft: '8px' }} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
